
import ServiceCard from "@/components/ServiceCard";

const ServicesSection = () => {
  return (
    <section className="section-padding bg-kaija-peach">
      <div className="container-custom">
        <h2 className="text-2xl md:text-3xl font-medium mb-4 text-center">Mida pakun</h2>
        <div className="grid grid-cols-1 md:grid-cols-3 gap-8 mt-12">
          <ServiceCard
            title="Somaatiline enesejuhtimise coaching"
            description="Coaching, mis ühendab keha ning meele ja keskendub sinu unikaalsetele vajadustele ja eesmärkidele turvalises ja toetavas keskkonnas."
            imageSrc="/images/20230730_100119.jpg"
            link="/somatic-coaching"
          />
          
          <ServiceCard
            title="Piiravad mõttemustrid"
            description="Hüpnoteraapia abil saame ligipääsu sinu alateadvusele, kus paljud piiravad mõttemustrid on talletunud, ning neid uurida ja ümber kujundada."
            imageSrc="/images/20230730_100726.jpg"
            link="/hypnotherapy"
          />
          
          <ServiceCard
            title="Koolitused ja meeskonnacoaching"
            description="Viige oma meeskond uuele tasemele läbi coaching'u ja trauma teadlikkuse tõstmise koolituste, et luua vastupidavam, ühtsem ja produktiivsem meeskond."
            imageSrc="/images/20230730_095937.jpg"
            link="/trainings"
          />
        </div>
      </div>
    </section>
  );
};

export default ServicesSection;
